import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../../../translation/namespace';
import { useFormContext } from '../../../../molecules/Form';
import IParameter from '../../../../../types/IParameter';
import { useContentWrapperContext } from '../../../../blocks/ContentWrapper/ContentWrapperContext';
import { BlockType } from '../../../../../types/api/ElementType';

export function AddContentBlockFormTemplate() {
  const { inputs } = useFormContext();
  const contentWrapperContext = useContentWrapperContext();
  const { t } = useTranslation();

  const getAddBlockTypeButton = (param: IParameter) => (
    <button
      key={param.name + param.value}
      type="submit"
      value={param.value}
      name={param.name}
      className="add-content-block-form__button"
    >
      {t(`${Namespace.glossary}:contentBlocks.${param.value}`)}
    </button>
  );

  // if we have multiple add forms = array
  if (Array.isArray(inputs.blockType)) {
    return (
      <>
        {inputs.blockType.filter((blockType) => {
          if (contentWrapperContext?.parentIndex) {
            return blockType.value !== BlockType.collapsiblecontainer;
          }

          return true;
        }).map(getAddBlockTypeButton)}
      </>);
  }

  return getAddBlockTypeButton(inputs.blockType);
}
